export default __webpack_public_path__ + "static/media/Stats_Storage.a6afd886.svg";